import React from 'react';
import styled from 'styled-components';
import { NO_TRANSLATE_CLASSNAME } from '../no-translate/translation.constants';

interface EstimateBoxTooltipProps {
    percentage: number;
    estimateValue: string;
}

const EstimateBoxTooltip = ({ percentage, estimateValue }: EstimateBoxTooltipProps) => (
    <ToolTipWapper>
        <TooltipText>
            <span>End of the month estimation: </span>
            <span className={NO_TRANSLATE_CLASSNAME}>{estimateValue}</span>
        </TooltipText>
        <TooltipText>
            <span>This is </span>
            <span className={NO_TRANSLATE_CLASSNAME}>{percentage} </span>
            <span>% comparing to the past 3 months</span>
        </TooltipText>
        <TooltipTriangle />
    </ToolTipWapper>
);

const TooltipText = styled.div`
    color: #ffffff;
    font-size: 12px;
    font-weight: 300;
    white-space: nowrap;
    `;

const ToolTipWapper = styled.div`
    background-color: #261f41;
    border-radius: 6px;
    left: 27%;
    padding:5px;
    position: absolute;
    text-align: center;
    top:-55px;
    `;

const TooltipTriangle = styled.div`
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #261f41;
    bottom: -10;
    left: 45%;
    position: relative;
    width: 0px;
`;

export default EstimateBoxTooltip;
